import { CountryCode, EventCategory } from '../enum';

export class CountryCodeHelper {
  static getAllCountryCodes(): CountryCode[] {
    return [
      CountryCode.AF,
      CountryCode.AL,
      CountryCode.DZ,
      CountryCode.AS,
      CountryCode.AD,
      CountryCode.AO,
      CountryCode.AI,
      CountryCode.AQ,
      CountryCode.AG,
      CountryCode.AR,
      CountryCode.AM,
      CountryCode.AW,
      CountryCode.AU,
      CountryCode.AT,
      CountryCode.AZ,
      CountryCode.BS,
      CountryCode.BH,
      CountryCode.BD,
      CountryCode.BB,
      CountryCode.BY,
      CountryCode.BE,
      CountryCode.BZ,
      CountryCode.BJ,
      CountryCode.BM,
      CountryCode.BT,
      CountryCode.BO,
      CountryCode.BA,
      CountryCode.BW,
      CountryCode.BV,
      CountryCode.BR,
      CountryCode.IO,
      CountryCode.VG,
      CountryCode.BN,
      CountryCode.BG,
      CountryCode.BF,
      CountryCode.BI,
      CountryCode.KH,
      CountryCode.CM,
      CountryCode.CA,
      CountryCode.CV,
      CountryCode.KY,
      CountryCode.CF,
      CountryCode.TD,
      CountryCode.CL,
      CountryCode.CN,
      CountryCode.CX,
      CountryCode.CC,
      CountryCode.CO,
      CountryCode.KM,
      CountryCode.CD,
      CountryCode.CG,
      CountryCode.CK,
      CountryCode.CR,
      CountryCode.HR,
      CountryCode.CU,
      CountryCode.CY,
      CountryCode.CZ,
      CountryCode.DK,
      CountryCode.DJ,
      CountryCode.DM,
      CountryCode.DO,
      CountryCode.TL,
      CountryCode.EC,
      CountryCode.EG,
      CountryCode.SV,
      CountryCode.GQ,
      CountryCode.ER,
      CountryCode.EE,
      CountryCode.ET,
      CountryCode.FK,
      CountryCode.FO,
      CountryCode.FJ,
      CountryCode.FI,
      CountryCode.FR,
      CountryCode.PF,
      CountryCode.TF,
      CountryCode.GA,
      CountryCode.GM,
      CountryCode.GE,
      CountryCode.DE,
      CountryCode.GH,
      CountryCode.GI,
      CountryCode.EL,
      CountryCode.GL,
      CountryCode.GD,
      CountryCode.GU,
      CountryCode.GT,
      CountryCode.GN,
      CountryCode.GW,
      CountryCode.GY,
      CountryCode.HT,
      CountryCode.HM,
      CountryCode.HN,
      CountryCode.HK,
      CountryCode.HU,
      CountryCode.IS,
      CountryCode.IN,
      CountryCode.ID,
      CountryCode.IR,
      CountryCode.IQ,
      CountryCode.IE,
      CountryCode.IL,
      CountryCode.IT,
      CountryCode.CI,
      CountryCode.JM,
      CountryCode.JP,
      CountryCode.JO,
      CountryCode.KZ,
      CountryCode.KE,
      CountryCode.KI,
      CountryCode.XK,
      CountryCode.KW,
      CountryCode.KG,
      CountryCode.LA,
      CountryCode.LV,
      CountryCode.LB,
      CountryCode.LS,
      CountryCode.LR,
      CountryCode.LY,
      CountryCode.LI,
      CountryCode.LT,
      CountryCode.LU,
      CountryCode.MO,
      CountryCode.MG,
      CountryCode.MW,
      CountryCode.MY,
      CountryCode.MV,
      CountryCode.ML,
      CountryCode.MT,
      CountryCode.MR,
      CountryCode.MU,
      CountryCode.YT,
      CountryCode.MX,
      CountryCode.FM,
      CountryCode.MD,
      CountryCode.MN,
      CountryCode.ME,
      CountryCode.MS,
      CountryCode.MA,
      CountryCode.MZ,
      CountryCode.MM,
      CountryCode.NA,
      CountryCode.NR,
      CountryCode.NP,
      CountryCode.NL,
      CountryCode.AN,
      CountryCode.NC,
      CountryCode.NZ,
      CountryCode.NI,
      CountryCode.NE,
      CountryCode.NG,
      CountryCode.NU,
      CountryCode.NF,
      CountryCode.MP,
      CountryCode.KP,
      CountryCode.NO,
      CountryCode.PS,
      CountryCode.OM,
      CountryCode.PK,
      CountryCode.PW,
      CountryCode.PA,
      CountryCode.PG,
      CountryCode.PY,
      CountryCode.PE,
      CountryCode.PH,
      CountryCode.PN,
      CountryCode.PL,
      CountryCode.PT,
      CountryCode.QA,
      CountryCode.MH,
      CountryCode.MK,
      CountryCode.RO,
      CountryCode.RU,
      CountryCode.RW,
      CountryCode.WS,
      CountryCode.SM,
      CountryCode.ST,
      CountryCode.SA,
      CountryCode.SN,
      CountryCode.RS,
      CountryCode.SC,
      CountryCode.SL,
      CountryCode.SG,
      CountryCode.SK,
      CountryCode.SI,
      CountryCode.SB,
      CountryCode.SO,
      CountryCode.ZA,
      CountryCode.GS,
      CountryCode.KR,
      CountryCode.ES,
      CountryCode.LK,
      CountryCode.SH,
      CountryCode.KN,
      CountryCode.LC,
      CountryCode.PM,
      CountryCode.VC,
      CountryCode.SD,
      CountryCode.SR,
      CountryCode.SZ,
      CountryCode.SE,
      CountryCode.CH,
      CountryCode.SY,
      CountryCode.TW,
      CountryCode.TJ,
      CountryCode.TZ,
      CountryCode.TH,
      CountryCode.TG,
      CountryCode.TK,
      CountryCode.TO,
      CountryCode.TT,
      CountryCode.TN,
      CountryCode.TR,
      CountryCode.TM,
      CountryCode.TC,
      CountryCode.TV,
      CountryCode.UG,
      CountryCode.UA,
      CountryCode.AE,
      CountryCode.UK,
      CountryCode.US,
      CountryCode.UM,
      CountryCode.UY,
      CountryCode.UZ,
      CountryCode.VU,
      CountryCode.VA,
      CountryCode.VE,
      CountryCode.VN,
      CountryCode.VI,
      CountryCode.WF,
      CountryCode.YE,
      CountryCode.ZM,
      CountryCode.ZW,
    ];
  }

  static getEuropeanCountryCodes(): CountryCode[] {
    return [
      CountryCode.AL,
      CountryCode.AT,
      CountryCode.BE,
      CountryCode.BA,
      CountryCode.BG,
      CountryCode.HR,
      CountryCode.CY,
      CountryCode.CZ,
      CountryCode.DK,
      CountryCode.EE,
      CountryCode.FI,
      CountryCode.FR,
      CountryCode.DE,
      CountryCode.EL,
      CountryCode.HU,
      CountryCode.IS,
      CountryCode.IE,
      CountryCode.IL,
      CountryCode.IT,
      CountryCode.LV,
      CountryCode.LI,
      CountryCode.LT,
      CountryCode.LU,
      CountryCode.MT,
      CountryCode.ME,
      CountryCode.NL,
      CountryCode.NO,
      CountryCode.PL,
      CountryCode.PT,
      CountryCode.MK,
      CountryCode.RO,
      CountryCode.RS,
      CountryCode.SK,
      CountryCode.SI,
      CountryCode.ES,
      CountryCode.SE,
      CountryCode.TR,
      CountryCode.UA,
    ];
  }

  static getCompatibleCountryCodesForCategoryAndCountryCodes(
    category: EventCategory,
    countryCodes: CountryCode[]
  ): CountryCode[] {
    let compatibleCountryCodes: CountryCode[];

    switch (category) {
      case EventCategory.EU_ENTREPRENEURSHIP_DAY_FOR_STUDENTS:
      case EventCategory.NATIONAL_AND_REGIONAL_EVENT:
      case EventCategory.EUROPEAN_LEVEL_EVENT:
        compatibleCountryCodes = CountryCodeHelper.getEuropeanCountryCodes();
        break;
      case EventCategory.CROSS_BORDER_EVENT:
      case EventCategory.INTERNATIONAL_EVENT:
        compatibleCountryCodes =
          CountryCodeHelper.getEuropeanCountryCodes().filter(ecc =>
            countryCodes.some(cc => cc === ecc)
          );
        break;
      default:
        throw new Error('not implemented.');
    }

    return compatibleCountryCodes;
  }
}
